import React, { useState, useEffect } from 'react';
import Sidebar from '../components/SideBar';
import Header from '../components/Header';
import useGlobale from '../components/global';
import useMenuItems from '../components/Menu';
import useNotifications from '../hooks/useNotifications';
import NotificationPageHeader from '../components/notifications/NotificationPageHeader';
import NotificationTabs from '../components/notifications/NotificationTabs';
import NotificationTabContent from '../components/notifications/NotificationTabContent';
import TemplateTabContent from '../components/notifications/TemplateTabContent';
import NotificationModals from '../components/notifications/NotificationModals';

const NotificationPage = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('notifications');
  const [filters, setFilters] = useState({
    search: '',
    type: '',
    cible: '',
    priorite: '',
    statut: '',
    programmee: '',
    ordering: '-created_at'
  });

  const { user } = useGlobale();
  const { menuItems } = useMenuItems();

  const {
    notifications,
    templates,
    statistics,
    loading,
    selectedNotification,
    selectedTemplate,
    showNotificationForm,
    showTemplateForm,
    showDetail,
    notificationsPagination,
    templatesPagination,
    handleNotificationPageChange,
    handleTemplatePageChange,
    setShowNotificationForm,
    setShowTemplateForm,
    setShowDetail,
    handleCreateNotification,
    handleEditNotification,
    handleViewDetail,
    handleSaveNotification,
    handleSendNotification,
    handleDeleteNotification,
    handleCreateTemplate,
    handleEditTemplate,
    handleSaveTemplate,
    handleDeleteTemplate,
    handleUseTemplate
  } = useNotifications(filters, activeTab);

  // Gestion responsive de la sidebar
  useEffect(() => {
    const handleResize = () => {
      setIsSidebarOpen(window.innerWidth >= 1024);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Handler pour création selon l'onglet actif
  const handleCreate = () => {
    if (activeTab === 'notifications') {
      handleCreateNotification();
    } else {
      handleCreateTemplate();
    }
  };

  return (
    <div className="flex min-h-screen bg-[#F4F8E9]">
      {/* Sidebar */}
      <Sidebar
        isOpen={isSidebarOpen}
        menuItems={menuItems}
        onClose={() => setIsSidebarOpen(false)}
      />

      <div className="flex-1 flex flex-col w-full">
        {/* Header */}
        <Header
          isSidebarOpen={isSidebarOpen}
          setIsSidebarOpen={setIsSidebarOpen}
          user={user}
        />

        {/* Contenu principal */}
        <main className="flex-1 w-full p-6">
          {/* En-tête de la page */}
          <NotificationPageHeader
            activeTab={activeTab}
            onCreateClick={handleCreate}
          />

          <div className="space-y-6">
            {/* Onglets */}
            <NotificationTabs
              activeTab={activeTab}
              onTabChange={setActiveTab}
            />

            {/* Contenu selon l'onglet actif */}
            {activeTab === 'notifications' ? (
              <NotificationTabContent
                statistics={statistics}
                filters={filters}
                onFilterChange={setFilters}
                notifications={notifications}
                loading={loading}
                onView={handleViewDetail}
                onEdit={handleEditNotification}
                onSend={handleSendNotification}
                onDelete={handleDeleteNotification}
                pagination={notificationsPagination}
                onPageChange={handleNotificationPageChange}
              />
            ) : (
              <TemplateTabContent
                templates={templates}
                loading={loading}
                onEdit={handleEditTemplate}
                onDelete={handleDeleteTemplate}
                onUse={handleUseTemplate}
                pagination={templatesPagination}
                onPageChange={handleTemplatePageChange}
              />
            )}
          </div>
        </main>
      </div>

      {/* Modales */}
      <NotificationModals
        showNotificationForm={showNotificationForm}
        showDetail={showDetail}
        showTemplateForm={showTemplateForm}
        selectedNotification={selectedNotification}
        selectedTemplate={selectedTemplate}
        onCloseNotificationForm={() => setShowNotificationForm(false)}
        onCloseDetail={() => setShowDetail(false)}
        onCloseTemplateForm={() => setShowTemplateForm(false)}
        onSaveNotification={handleSaveNotification}
        onSaveTemplate={handleSaveTemplate}
        onEditNotification={handleEditNotification}
        onDeleteNotification={handleDeleteNotification}
      />
    </div>
  );
};

export default NotificationPage;
